import makeStyles from '@material-ui/styles/makeStyles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FilterSVG } from '../../../../assets/images/icon-filter-main.svg';
export interface IAdvancedChecklist {
    active: boolean;
    selectedFiltersCount: number;
}

const useStyles = makeStyles({
    FiltersUI: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.625rem 0.9375rem',
        border: '0.5px solid #AAB6D3',
        borderRadius: '8px',
        height: '2.5rem',
        float: 'right',
        '& >p': {
            fontSize: '0.875rem',
            color: '#212121',
            marginLeft: '10px',
        },
        '& >div:first-child': {
            width: '1.125rem',
            height: '1.125rem',
            borderRadius: '50%',
            backgroundColor: '#FFDD02',
            textAlign: 'center',
            fontSize: '0.75rem',
            fontWeight: 600,
            color: '#212121',
        },
        '&:hover': {
            cursor: 'pointer',
        },
    },
    FiltersUIActive: {
        border: '1px solid #FFDD02 !important',
        backgroundColor: '#FAF6E0 !important',
        '& >p': {
            fontSize: '0.875rem !important',
            color: '#212121 !important',
        },
        '& >svg': {
            fill: '#FFDD02',
        },
    },
});
function FiltersUI(props: IAdvancedChecklist) {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <div className={`${classes.FiltersUI} ${props.active ? classes.FiltersUIActive : ''}`}>
            {props.selectedFiltersCount > 0 ? (
                <div>{props.selectedFiltersCount}</div>
            ) : (
                <FilterSVG width="1rem" height="1rem" />
            )}
            <p>{t('misc.filters')}</p>
        </div>
    );
}

export default FiltersUI;
